import { AlertMargin, StyledAlert } from "App/global-style";
import { replaceUserSupportNumberInText } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/utils";
import { usePartnerId } from "Store/partners/partnerHooks";
import React from "react";

interface Props {
  readonly customMaximumPayoutText: string;
  readonly customText: string;
  readonly purchaseFromAdvisor: any;
  readonly lang: string;
  readonly marginBottom?: AlertMargin;
}

export const PurchaseFromAdvisorAlert = ({
  customMaximumPayoutText,
  customText,
  purchaseFromAdvisor,
  lang,
  marginBottom,
}: Props): React.ReactElement => {
  const partnerId = usePartnerId();

  const weAdvice: string = purchaseFromAdvisor.weAdvice[lang]
    .replace("{{payment}}", customText)
    .replace("{{isMaximumPayout}}", customMaximumPayoutText);

  return (
    <StyledAlert
      className="PurchaseFromAdvisorText"
      title={replaceUserSupportNumberInText(
        partnerId,
        purchaseFromAdvisor.userSupportNumber,
        weAdvice,
        lang,
      )}
      marginBottom={marginBottom}
    />
  );
};
